import * as React from 'react';
import { PageTitle } from 'pages/Report/components/ReportPageLayout';
import FoodWasteDistribution from 'pages/Report/components/FoodWasteDistribution';
import { Card, CardContent, CardHeader, Grid } from '@material-ui/core';
import FactsOverview from './components/FactsOverview';
import FoodWasteStatus from './components/FoodWasteStatus';
import { Basis, ReportFilterState } from 'redux/ducks/reportFilter';
import { useIntl } from 'react-intl';
import getFormattedTimeRange from 'pages/Report/utils/getFormattedDateRange';

interface ComponentProps {
  basis: Basis;
  downloadButton: React.ReactNode;
  filter: ReportFilterState;
}

const FoodWaste: React.FunctionComponent<ComponentProps> = (props) => {
  const intl = useIntl();
  const {
    basis,
    downloadButton,
    filter: {
      timeRange: { from: startDate, to: endDate },
      period
    }
  } = props;
  return (
    <>
      <PageTitle>
        {basis === 'per-guest'
          ? intl.formatMessage({ id: 'report.foodwaste.perGuest.title' })
          : intl.formatMessage({ id: 'report.totalFoodwaste.title' })}
      </PageTitle>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <FactsOverview />
        </Grid>
        <Grid item xs={12}>
          <FoodWasteStatus />
        </Grid>
        <Grid item xs={12}>
          <Card>
            <CardHeader
              title={intl.formatMessage({ id: 'report.foodwaste.overviewPercentages.title' })}
              subheader={intl.formatMessage(
                {
                  id:
                    basis === 'per-guest'
                      ? 'report.foodwaste.perGuest.overviewPercentages.description'
                      : 'report.foodwaste.total.overviewPercentages.description'
                },
                {
                  range: getFormattedTimeRange(startDate, endDate),
                  period: intl.formatMessage({ id: period }).toLowerCase()
                }
              )}
            />
            <CardContent>
              <FoodWasteDistribution />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      {downloadButton}
    </>
  );
};

export default FoodWaste;
